

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"3","height":"6"}, rest), [h('path', {"fill":"#000","fill-rule":"evenodd","d":"M2.625.5a.375.375 0 1 1 0 .75H1.94v3.5h.685a.375.375 0 1 1 0 .75H.375a.375.375 0 1 1 0-.75h.715v-3.5H.375a.375.375 0 0 1 0-.75h2.25Z"}, [])]);
};

        